module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/faq_photograph_01_sp-2f8e10a86b4edd41b5919a09405441c7.png";